import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseService } from '@app/system/services/base.service';
import { DetectDeviceService } from '@app/system/services/detect-device.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';

@Component({
	selector: 'app-mooc-detail',
	templateUrl: './mooc-detail.component.html',
	styleUrls: ['./mooc-detail.component.scss']
})
export class MoocDetailComponent implements OnInit {

	@Input() resourceDetail: any = {};
	@Input() popupRef;
	@Output() readLogEmit = new EventEmitter();
	currentUser;
	skillMPermission = false;
	constructor(
		public locale: LocaleService,
		public detectDevice: DetectDeviceService,
		public gfService: GlobalFunctionService,
		private baseService: BaseService
	) {
		this.currentUser = this.gfService.sessionUser;
	}

	ngOnInit(): void {
		if (this.baseService.checkModuleAccess('M13')) {
			this.skillMPermission = true;
		}
	}

	embedLink(url) {
		if (navigator.onLine) {
			this.gfService.windowNavigate(url, '_blank');
		}
	}

	emitReadLog() {
		this.readLogEmit.emit(true);
	}

}
